module.exports = __webpack_public_path__ + "static/media/client20.0c1082d0.webp";